import { CoreImageView } from '@core/widgets';
import { AssetsSvgMap } from '@libs/types';
import { Loading } from '@libs/utils';
import clsx from 'clsx';
import React, { Suspense, useDeferredValue, useMemo, useState } from 'react';
import { TConsumerItem } from '../../../types/data';
import { getHref } from '../../Image/imageUtils';
import { TextCommon } from '../../UI/Text/TextCommon';
import InputSearch from '../InputSearch';
import ListItems, { TListItemProps } from '../ListItems';
import styles from '../styles/styles.module.css';
import { filterBySearch } from '../utils/search';

type TListSearchPopupProps = {
    renderItem: React.FC<TListItemProps>;
    items: TConsumerItem[];
    index: number;
    header: string;
    noFoundText?: string;
    searchPlaceholder?: string;
};

const ListSearchPopup = ({ items, renderItem, index, header, searchPlaceholder, noFoundText = '' }: TListSearchPopupProps) => {
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [query, setQuery] = useState('');
    const deferredQuery = useDeferredValue(query);
    const hasItems = items && Array.isArray(items) && items.length > 0;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => setQuery(e.target.value);

    const memorizedItems = useMemo(() => (deferredQuery ? filterBySearch(deferredQuery, items) : []), [items, deferredQuery]);

    const searchBlock = !isSearchMode ? (
        <>
            <div className={styles.header}>{header}</div>
            <InputSearch
                searchPlaceholder={searchPlaceholder}
                uid="inputSearch"
                asButton={true}
                handleClick={() => setIsSearchMode(true)}
                marginBottom={24}
                marginLeft={24}
                marginRight={24}
            />
        </>
    ) : (
        <InputSearch
            searchPlaceholder={searchPlaceholder}
            uid="inputSearch"
            asButton={false}
            isSearchInput={true}
            value={query}
            autoFocus={true}
            handleChange={handleChange}
            marginBottom={16}
            handleCloseClick={() => {
                setIsSearchMode(false);
                setQuery('');
            }}
            backIcon={AssetsSvgMap.ic_chevron_down}
            handleClickRightComponent={() => setQuery('')}
        />
    );
    return (
        <Suspense fallback={<Loading />}>
            {searchBlock}
            {memorizedItems.length > 0 && <ListItems items={memorizedItems} renderItem={renderItem} currentIndex={index} />}
            {!deferredQuery && memorizedItems.length === 0 && hasItems && <ListItems items={items} renderItem={renderItem} currentIndex={index} />}
            {deferredQuery && memorizedItems.length === 0 && (
                <div className={clsx(styles.emptyContainer, styles.leftCenterAligned)}>
                    <CoreImageView
                        src={getHref(AssetsSvgMap.ic_ghost)}
                        styleProps={{
                            iconColor: `var(--color-grey_72_lc)`,
                        }}
                    />
                    <TextCommon
                        isWidget={false}
                        content={`${noFoundText} "${query}"`}
                        options={{ variant: 'secondary', textColor: 'grey_72_lc', margin: { top: 16 } }}
                    />
                </div>
            )}
        </Suspense>
    );
};
export default ListSearchPopup;
